// Status zapisu pola obok inputa/checkboxa (element `.intum-field-status`): kręciołek w trakcie,
// zielona fajka po sukcesie (znika po SAVED_CHECK_MS), czerwony krzyżyk przy błędzie (zostaje).
// Używają IntumJs.setField i kontroler dynamic-checkbox.

export const SAVED_CHECK_MS = 1000

export const SPINNER_SVG = "<svg class=\"animate-spin h-4 w-4 text-gray-400\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\"></path></svg>"
export const CHECK_SVG = "<svg class=\"h-4 w-4 text-green-700\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"/></svg>"
export const ERROR_SVG = "<svg class=\"h-4 w-4 text-red-700\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z\" clip-rule=\"evenodd\"/></svg>"

// Ustawia zawartość statusu i kasuje zaplanowane schowanie fajki - nowy zapis tego samego pola
// (kręciołek) nie może zniknąć przez timer poprzedniego
function setStatus(el, html) {
  clearTimeout(el.intumStatusTimer)
  el.intumStatusTimer = null
  el.innerHTML = html
}

export function showSpinner(el) {
  if (el) setStatus(el, SPINNER_SVG)
}

// Fajka po udanym zapisie - po `delay` ms status robi się pusty (zarezerwowane miejsce zostaje)
export function showSavedCheck(el, delay = SAVED_CHECK_MS) {
  if (!el) return
  setStatus(el, CHECK_SVG)
  el.intumStatusTimer = setTimeout(() => {
    el.intumStatusTimer = null
    el.innerHTML = ""
  }, delay)
}

export function showError(el) {
  if (el) setStatus(el, ERROR_SVG)
}
